import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './styles.less';

const PullQuote = (props) => {
    return (
        <aside
            className={classNames({
                'p-pull-quote': true,
                [`p-pull-quote--float-${props.float}`]: true
            })}
            data-content-id={props.contentId}
        >
            <blockquote>
                <p className="p-pull-quote__text">{props.text}</p>
                {props.attribution ? <cite className="p-pull-quote__attribution">{props.attribution}</cite> : null}
            </blockquote>
        </aside>
    );
};

PullQuote.propTypes = {
    float: PropTypes.oneOf(['Left', 'left', 'None', 'none', 'Right', 'right']),
    text: PropTypes.string.isRequired,
    attribution: PropTypes.string,
    contentId: PropTypes.string
};

PullQuote.defaultProps = {
    float: 'none',
    attribution: undefined,
    contentId: undefined
};

export default PullQuote;
